/**
 * İmzacının sürümü ve kabuk sürümüne bağlı özellik algılama (DEV-3904).
 *
 * İmzacı arayüzü sunucudan servis edilir ve sahadaki ESKİ kabuklarla da çalışmak
 * zorundadır. Yeni bir özel istek başlığı eklemek yeni kabuk gerektirir: imzacı
 * `https://imza.eicrapro.com:6090`'a ÇAPRAZ ORİGİN istek atar ve tarayıcı ön kontrolü
 * (OPTIONS) `Access-Control-Allow-Headers` listesinde olmayan her başlığı reddeder.
 * Kabuk <= 2.0.4'ün listesinde X-Imzaci-* yoktur; yine de gönderilirse imzacının TÜM
 * /api istekleri (next-task dahil) tarayıcı düzeyinde düşer ve bot tamamen durur. Bu
 * yüzden başlıklar yalnız kabukSurumu >= 2.0.5 iken gönderilir.
 *
 * Saf tutuldu (store/DOM bağımlılığı yok) ki birim testten geçebilsin.
 */

/** İlk üç sayısal bileşen; ayrıştırılamıyorsa null. '2.0.5-beta.1' -> [2,0,5]. */
function surumParcalari(surum: unknown): number[] | null {
    const e = /^\s*v?(\d+)\.(\d+)\.(\d+)/.exec(typeof surum === 'string' ? surum : '');
    return e ? [Number(e[1]), Number(e[2]), Number(e[3])] : null;
}

/** a < b ise -1, eşitse 0, a > b ise 1. Ayrıştırılamayan sürüm 0.0.0 sayılır. */
export function surumKarsilastir(a: string, b: string): number {
    const x = surumParcalari(a) ?? [0, 0, 0];
    const y = surumParcalari(b) ?? [0, 0, 0];
    for (let i = 0; i < 3; i++) {
        if (x[i] !== y[i]) {
            return x[i] < y[i] ? -1 : 1;
        }
    }
    return 0;
}

/** Kabuk X-Imzaci-* başlıklarını CORS izin listesine ekleyen ilk sürüm. */
export const KABUK_BASLIK_DESTEGI_SURUMU = '2.0.5';

/** kabukSurumu >= 2.0.5 mi (tanımsız/ayrıştırılamayan = eski kabuk = false). */
export function kabukBaslikDestegiVarMi(kabukSurumu: string | undefined | null): boolean {
    if (typeof kabukSurumu !== 'string' || surumParcalari(kabukSurumu) === null) {
        return false;
    }
    return surumKarsilastir(kabukSurumu, KABUK_BASLIK_DESTEGI_SURUMU) >= 0;
}

/** X-Imzaci-Surum başlığının değeri: '<imzacı sürümü>;kabuk=<kabuk sürümü|bilinmiyor>'. */
export function imzaciSurumBasligi(surum: string, kabukSurumu: string | undefined | null): string {
    return surum + ';kabuk=' + (kabukSurumu || 'bilinmiyor');
}

/**
 * İmzacı arayüzünün sürümü: derlemede vue.config.js `VUE_APP_SURUM` olarak gömer
 * (package.json sürümü + kısa commit). Gömülmediyse 'bilinmiyor'.
 */
export function imzaciSurumu(): string {
    return process.env.VUE_APP_SURUM || 'bilinmiyor';
}
